import React from "react"
import clsx from "clsx"
import { formatHours } from "../lib/hours"

const FooterRow = ({ days, template, label, counts, total }) => (
  <div className="grid sticky bottom-0 z-[8] border-t border-slate-200 bg-white" style={{ gridTemplateColumns: template }}>
    <div className="sticky left-0 z-[9] flex items-center px-3 h-9 bg-white border-r border-slate-200">
      <span className="text-[10.5px] font-semibold uppercase tracking-wider text-slate-400 truncate">{label}</span>
    </div>
    {days.map(day => {
      const count = counts[day.date] || 0
      return (
        <div key={day.date} className={clsx("flex items-center justify-center border-r border-slate-100", day.weekend || day.holiday ? "bg-slate-50" : "bg-white")}>
          <span className={clsx(
            "min-w-[22px] h-5 px-1.5 rounded-full grid place-items-center text-[11px] font-semibold tabular-nums",
            count > 0 ? "bg-brand-50 text-brand-700" : "text-slate-300",
          )}>
            {count}
          </span>
        </div>
      )
    })}
    <div className="flex items-center justify-end px-3 text-[12.5px] font-semibold text-slate-800 tabular-nums">{formatHours(total)}</div>
  </div>
)

export default FooterRow
